import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import customTheme from './src/@chakra-ui/gatsby-plugin/theme';

export const wrapRootElement = ({ element }) => {
  return <ChakraProvider theme={customTheme}>{element}</ChakraProvider>;
};
